import React, { useState, useEffect, useRef } from "react";
import { 
  TextField, 
  Box, 
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useTranslation } from 'react-i18next';
import { useSnackbar } from "../../providers/SnackBarProvider";
import { useAppBar } from "../../providers/AppBarProvider";
import { useLoading } from "../../providers/LoadingProvider";
import EditPage from "./EditPage";
import { handleError, validateNonEmpty } from "../../utils/lib";

const EditVetPoint = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const snackbar = useSnackbar();
  const { updateTitle, toggleFab } = useAppBar();
  const { isLoading, setIsLoading } = useLoading();

  const [point, setPoint] = useState({
    name: "",
    number: "",
    type: "PAPER"
  });

  const [errors, setErrors] = useState({});
  const [refs, setRefs] = useState({
    name: useRef(null),
    number: useRef(null),
    type: useRef(null),
  });

  useEffect(() => {
    updateTitle(undefined, t('edit.editEmissionPoint'), t('edit.fillData'));
    toggleFab(false);
    refs.name.current?.focus();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPoint(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    if (!validateNonEmpty("name", point.name, setErrors, refs.name) ||
        !validateNonEmpty("number", point.number, setErrors, refs.number)) {
      return;
    }

    setIsLoading(true);
    try {
      await axios.post(
        `${import.meta.env.VITE_API_URL}vets?create_point`,
        point,
        { withCredentials: true }
      );

      navigate("/main/view-vet-points");
    } catch (error) {
      handleError(error);
      snackbar(t('common.errorSaving'));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <EditPage 
      onSubmit={handleSubmit}
      isLoading={isLoading}
    >
      <Box sx={{ width: "100%" }}>
        <TextField
          fullWidth
          margin="normal"
          label={t('common.nameStar')}
          name="name"
          value={point.name}
          onChange={handleChange}
          inputRef={refs.name}
          error={!!errors.name}
          helperText={errors.name}
        />

        <TextField
          fullWidth
          margin="normal"
          label={t('edit.numberStar')}
          name="number"
          value={point.number}
          onChange={handleChange}
          inputRef={refs.number}
          error={!!errors.number}
          helperText={errors.number}
        />

        <FormControl fullWidth margin="normal">
          <InputLabel>{t('edit.typeStar')}</InputLabel>
          <Select
            name="type"
            value={point.type}
            label={t('edit.typeStar')}
            onChange={handleChange}
            inputRef={refs.type}
          >
            <MenuItem value="PAPER">{t('edit.paperType')}</MenuItem>
            <MenuItem value="ELECTRONIC">{t('edit.electronicType')}</MenuItem>
          </Select>
        </FormControl>
      </Box>
    </EditPage>
  );
};

export default EditVetPoint; 